import { useSelector } from 'react-redux';
import { SectionAlert, Surface, Txt } from '@vst/beam';
import { CalendarToday } from '@vst/beam-icons/icons';
import { addHours, format, parseISO } from 'date-fns';
import { useTranslation } from 'react-i18next';

import { getDateFormat } from '@app/services/translations/formats';
import { selectScheduleInstallation } from '@app/redux/scheduleInstallation';

import { Locale } from '@mfe/shared/schema-types';

import styles from './current-schedule.module.scss';

const CurrentSchedule = () => {
  const { installDate } = useSelector(selectScheduleInstallation);
  const { t } = useTranslation('ScheduleInstallation', {
    keyPrefix: 'currentSchedule',
  });

  if (!installDate) return null;

  const formattedDate = format(new Date(installDate), getDateFormat(Locale.EnUs, 'medium_install_precise'));
  const from = new Date(installDate);
  const to = new Date(addHours(parseISO(installDate), 3));

  return (
    <Surface data-cy="current-schedule" radius="8px" className={styles['container']}>
      <SectionAlert icon={CalendarToday} variant="infoSecondary" size="small">
        <Txt data-cy="current-schedule-message" variant="smallRegular" color="regular">
          {t('message')}
          <Txt variant="smallBold" component="span">
            {t('date', { formattedDate, from, to })}
          </Txt>
        </Txt>
      </SectionAlert>
    </Surface>
  );
};

export default CurrentSchedule;
